import { getProxyUrl } from 'academy-common-lib/utils/url';
// @ts-expect-error Could not find a declaration file for module
import defaultShareImage from 'bender-url!../../images/default-share-image.png';
import PublicPageLayout from '../features/publicLayout/components/PublicPageLayout';
import { supportedPublicLanguages } from 'academy-common-lib/constants/academySupportedLanguages';
import DocumentHead from '../features/publicSeo/components/DocumentHead';
import { NavMarker } from 'react-rhumb';
import OpenGraph from '../features/publicSeo/components/OpenGraph';
import I18n from 'I18n';
import { useEffect } from 'react';
import usageTracker from '../utils/usageTracker';
import AlternateLanguageLinks from '../features/publicSeo/components/AlternateLanguageLinks';
import PublicPageHeader from '../features/publicLayout/components/PublicPageHeader';
import FormattedMessage from 'I18n/components/FormattedMessage';
import HorizontalLayoutContainer from '../features/publicLayout/components/HorizontalLayoutContainer';
import UISection from 'UIComponents/section/UISection';
import PublicPageAboutAcademySection from '../features/publicPresentation/components/PublicPageAboutAcademySection';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { PublicCatalogDropdown, PublicCatalogSearchInput, PublicCatalogFilters, PublicCatalogMobileFilters, PublicCatalogResults, PublicCatalogResultsBar } from '../features/publicCatalog';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import PublicCatalogMobileCategoriesMenu from '../features/publicCatalog/components/PublicCatalogMobileCategoriesMenu';
import { useLocation } from 'react-router-dom';
import ErrorBoundary from '../components/ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PublicCatalogPage = () => {
  const {
    isMobile
  } = useMediaQuery();
  const location = useLocation();
  useEffect(() => {
    document.title = I18n.text('academyPublic.catalogPage.pageTitle');
    usageTracker.track('pageView', {
      screen: 'catalog-page',
      subscreen: 'catalog-page'
    });
  }, []);
  return /*#__PURE__*/_jsxs(PublicPageLayout, {
    availableLanguages: [...supportedPublicLanguages],
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "CATALOG_PAGE_LOAD"
    }), /*#__PURE__*/_jsx(ErrorBoundary, {
      errorMessage: null,
      children: /*#__PURE__*/_jsxs(DocumentHead, {
        children: [/*#__PURE__*/_jsx("link", {
          href: getProxyUrl(location.pathname),
          rel: "canonical"
        }), /*#__PURE__*/_jsx(AlternateLanguageLinks, {
          languages: [...supportedPublicLanguages]
        }), /*#__PURE__*/_jsx("meta", {
          content: I18n.text('academyPublic.catalogPage.pageDescription'),
          name: "description"
        }), /*#__PURE__*/_jsx(OpenGraph, {
          description: I18n.text('academyPublic.catalogPage.pageDescription'),
          image: defaultShareImage.replace('//', 'https://'),
          imageAlt: I18n.text('academyPublic.defaultThumbnailAltText'),
          title: I18n.text('academyPublic.catalogPage.pageTitle'),
          url: getProxyUrl(location.pathname)
        })]
      })
    }), /*#__PURE__*/_jsx(ErrorBoundary, {
      children: /*#__PURE__*/_jsx(PublicPageHeader, {
        badgeText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.catalogPage.badgeText"
        }),
        description: /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.catalogPage.description"
          })
        }),
        heading: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.catalogPage.heading"
        }),
        children: /*#__PURE__*/_jsxs(UIFlex, {
          align: "center",
          className: isMobile ? 'm-top-10' : 'm-y-10',
          gap: 20,
          justify: "center",
          wrap: isMobile ? 'wrap' : 'nowrap',
          children: [!isMobile && /*#__PURE__*/_jsx(PublicCatalogDropdown, {}), /*#__PURE__*/_jsx(UIBox, {
            basis: "100%",
            grow: 1,
            style: {
              maxWidth: isMobile ? 'none' : '400px'
            },
            children: /*#__PURE__*/_jsx(PublicCatalogSearchInput, {})
          }), isMobile && /*#__PURE__*/_jsx(PublicCatalogMobileCategoriesMenu, {})]
        })
      })
    }), /*#__PURE__*/_jsxs(ErrorBoundary, {
      children: [!isMobile && /*#__PURE__*/_jsx(PublicCatalogResultsBar, {}), isMobile && /*#__PURE__*/_jsx(PublicCatalogMobileFilters, {})]
    }), /*#__PURE__*/_jsx(UISection, {
      className: "p-bottom-15",
      children: /*#__PURE__*/_jsxs(HorizontalLayoutContainer, {
        className: "p-top-1",
        children: [/*#__PURE__*/_jsx(ErrorBoundary, {
          children: !isMobile && /*#__PURE__*/_jsx(PublicCatalogFilters, {})
        }), /*#__PURE__*/_jsx(ErrorBoundary, {
          children: /*#__PURE__*/_jsx(PublicCatalogResults, {})
        })]
      })
    }), /*#__PURE__*/_jsx(UISection, {
      className: "m-bottom-0",
      children: /*#__PURE__*/_jsx(HorizontalLayoutContainer, {
        children: /*#__PURE__*/_jsx(PublicPageAboutAcademySection, {})
      })
    })]
  });
};
export default PublicCatalogPage;